export default {
  independentMarketing: {
    common: {
      requestFailed: 'សំណើចំណុចប្រទាក់បានបរាជ័យ',
      hintSelect: 'ជ្រើសរើស',
      hintInput: 'បញ្ចូល',
      submit: 'ដាក់ស្នើ',
      cancel: 'បោះបង់',
      confirm: 'យល់ព្រម',
    },
    agreement: {
      title: 'កិច្ចព្រមព្រៀងចុះឈ្មោះអ្នកចែកបៀឯករាជ្យ Autel',
      nextBtn: 'បន្ទាប់',
      getAgreementFailed: 'បរាជ័យក្នុងការទទួលបានខ្លឹមសារកិច្ចព្រមព្រៀង។',
    },
    successPage: {
      title:
        'ព័ត៌មានអំពីពាក្យសុំរបស់អ្នកត្រូវបានបញ្ជូនដោយជោគជ័យ ហើយលទ្ធផលពិនិត្យនឹងត្រូវបានផ្ញើទៅអ៊ីមែលរបស់អ្នក $1 ក្នុងរយៈពេល 15 ថ្ងៃធ្វើការ។ សូមពិនិត្យមើលប្រអប់សំបុត្ររបស់អ្នកសម្រាប់ព័ត៌មានបន្ថែម។',
      subTitle: 'ត្រឡប់ទៅទំព័រដើមវិញបន្ទាប់ពី $1 វិនាទី។',
    },
    applyTitle: 'អ្នកកំពុងដាក់ពាក្យក្លាយជាអ្នកចែកចាយឯករាជ្យ Autel។ សូមបំពេញព័ត៌មានខាងក្រោមឲ្យបានត្រឹមត្រូវ៖',
    companyName: 'ឈ្មោះ​ក្រុម​ហ៊ុន',
    companyTax: 'លេខសម្គាល់ពន្ធលើតម្លៃបន្ថែម',
    userCountry: 'ប្រទេស',
    legalPerson: 'ទីប្រឹក្សាច្បាប់',
    contactEmail: 'អ៊ីមែលទំនាក់ទំនង',
    contactEmailTips:
      'អាសយដ្ឋានអ៊ីមែលនេះនឹងក្លាយជាទំនាក់ទំនងរបស់អ្នក អ៊ីមែលលទ្ធផលពិនិត្យ។ នៅពេលដែលការត្រួតពិនិត្យត្រូវបានអនុម័ត វាក៏នឹងត្រូវបានប្រើជាឈ្មោះគណនីចូលសម្រាប់ប្រព័ន្ធគ្រប់គ្រងអ្នកចែកបៀឯករាជ្យផងដែរ។',
    corporateIdentity: 'លេខសម្គាល់អ្នកប្រឹក្សាច្បាប់',
    uploadTips: 'JPG, JPEG, PNG, PDF (មិនធំជាង 20 MB)',
    businessLicense: 'អាជ្ញាប័ណ្ណអាជីវកម្ម',
    emailErrorTips: 'បញ្ចូលអ៊ីមែលត្រឹមត្រូវ។',
    uploadPic: 'បង្ហោះរូបភាព',
    picMaxLimit: 'ទំហំរូបភាពអតិបរមាគឺ 20 MB ។ សូមជ្រើសរើសម្តងទៀត។',
  },
};
